export default __webpack_public_path__ + "static/gears5-9cca963f1396a766ce396a46bb2cd146.jpg";